import { useMemo } from 'react'
import { permissionTypes } from '@/enums/permissionTypes'
import { usePermissionsForInstitutions } from '@/hooks/usePermissionsForInstitutions'

const useIndividualPermissionChecker = (institutionIds) => {
  const { individualEdit, individualReadOnly } = usePermissionsForInstitutions(institutionIds)
  return useMemo(() => {
    return function getIndividualPermission (permissionNumber) {
      if (individualEdit & permissionNumber) {
        return permissionTypes.enum.Edit
      }

      if (individualReadOnly & permissionNumber) {
        return permissionTypes.enum.ReadOnly
      }

      return permissionTypes.enum.None
    }
  }, [individualEdit, individualReadOnly])
}

export { useIndividualPermissionChecker }



// WEBPACK FOOTER //
// ./src/hooks/useIndividualPermissionChecker.js